window.GacJSBridge = {};
var androidIsConfiged = false;
var androidCallbackLists = [];
var u = window.navigator.userAgent;

// var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
// var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;

// 提供了新的方法去判断
const isiOS = u.indexOf("hycan_ios") > -1;
const isAndroid = u.indexOf("hycan_android") > -1;

//注册事件监听，初始化
window.setupWebViewJavascriptBridge = function(callback) {
  console.log("------------");
  if (!isiOS) {
    if (window.WebViewJavascriptBridge) {
      callback(window.WebViewJavascriptBridge);
      androidIsConfiged = true;
      if (androidCallbackLists.length) {
        androidCallbackLists.forEach((callbacks) => {
          callbacks === "function" && callbacks();
        });
        androidCallbackLists = [];
      }
    } else {
      document.addEventListener(
        "WebViewJavascriptBridgeReady",
        function() {
          console.log("WebViewJavascriptBridgeReady触发");
          callback(window.WebViewJavascriptBridge);
          androidIsConfiged = true;
          if (androidCallbackLists.length) {
            console.log("队列存在，开始广播");
            androidCallbackLists.forEach((callbacks) => {
              typeof callbacks === "function" && callbacks();
            });
            androidCallbackLists = [];
          }
        },
        false
      );
    }
  } else {
    if (window.WKWebViewJavascriptBridge) {
      return callback(window.WKWebViewJavascriptBridge);
    }
    if (window.WKWVJBCallbacks) {
      return window.WKWVJBCallbacks.push(callback);
    }
    window.WKWVJBCallbacks = [callback];
    window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.iOS_Native_InjectJavascript &&
      window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage &&
      window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(
        null
      );
  }
};
console.log("----------------");
//回调函数，接收java发送来的数据
window.setupWebViewJavascriptBridge(function(bridge) {
  //默认接收
  //默认接收
  if (!isiOS) {
    bridge.init(function(message, responseCallback) {
      var responseData = "js默认接收完毕，并回传数据给java";
      responseCallback(responseData); //回传数据给java
    });
  }

  window.GacJSBridge = bridge;
});
let brdgeObj = {
  init(cb) {
    let platform = "";
    if (isiOS) {
      platform = "ios";
    }
    if (isAndroid) {
      platform = "android";
    }
    this.isMiniProgram().then((res) => {
      if (res !== "not in wx") platform = res;
      cb(platform);
    });
  },
  jsCallApp(data, fn) {
    if (isiOS) {
      window.GacJSBridge &&
        window.GacJSBridge.callHandler &&
        window.GacJSBridge.callHandler("GacJSBridge", data, function(res) {
          fn && fn(res);
        });
    }
    if (isAndroid) {
      if (!androidIsConfiged) {
        console.log("android没初始化完成加入回调队列");
        androidCallbackLists.push((_) => {
          console.log("队列中的回调", data, fn);
          window.WebViewJavascriptBridge &&
            window.WebViewJavascriptBridge.callHandler(
              "GacJSBridge",
              data,
              function(res) {
                fn && fn(res);
              }
            );
        });
        return;
      }
      window.WebViewJavascriptBridge &&
        window.WebViewJavascriptBridge.callHandler(
          "GacJSBridge",
          data,
          function(res) {
            fn && fn(res);
          }
        );
    }
  },
  registerHandler(eventName, fn) {
    //指定接收，参数functionInJs 与java保持一致
    if (isiOS || isAndroid) {
      window.GacJSBridge.registerHandler(eventName, function(
        data,
        responseCallback
      ) {
        var responseData = "get";
        responseCallback(responseData); //回传数据给java
        fn && fn(data);
      });
    }
  },
  isMiniProgram() {
    return new Promise((resolve) => {
      //是否为字节跳动小程序
      const isTTWebView = navigator.userAgent
        .toLowerCase()
        .includes("toutiaomicroapp");
      if (isTTWebView) {
        tt.miniProgram.getEnv((res) => {
          console.log("字节跳动小程序", res);
          if (res.miniprogram) {
            resolve("tt_miniprogram");
          } else {
            resolve("WXH5");
          }
        });
        return;
      }
      if (-1 == navigator.userAgent.toLowerCase().indexOf("micromessenger")) {
        resolve("not in wx");
      } else {
        //微信小程序
        window.wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
            resolve("miniprogram");
          } else {
            resolve("WXH5");
          }
        });
      }
    });
  },
};
brdgeObj.init((pf) => {
  console.log(`当前平台 -  旧版本- ${pf}`);
});
export default brdgeObj;
